import { Button } from '@/General/Button'
import { Modal } from '@/Modal/Modal'
import { stacks } from './stack-config'
import { getCardDisplay } from './card-utils'

interface StackViewModalProps {
  isOpen: boolean
  onClose: () => void
  selectedStackName: string
}

export const StackViewModal = ({
  isOpen,
  onClose,
  selectedStackName
}: StackViewModalProps) => {
  const selectedStack = stacks.find(s => s.name === selectedStackName)

  if (!selectedStack) {
    return null
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${selectedStack.name} by ${selectedStack.creator}`}
      maxWidth="2xl"
    >
      <div className="mt-4">
        <div className="grid grid-cols-4 gap-2" id="stack-order-container">
          {selectedStack.order.split(',').map((card, index) => {
            const trimmedCard = card.trim()
            const isRed = trimmedCard.endsWith('H') || trimmedCard.endsWith('D')
            return (
              <div key={index} className="col">
                <div className={`border p-2 ${isRed ? 'text-red-500' : ''}`}>
                  <strong>{index + 1}:</strong> {getCardDisplay(trimmedCard)}
                </div>
              </div>
            )
          })}
        </div>
      </div>
      
      <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse mt-4 -m-4">
        <Button onClick={onClose} color="blue" className="sm:ml-3">
          Close
        </Button>
      </div>
    </Modal>
  )
}